export const API_URL =
  process.env.REACT_APP_API_URL || "https://api.getnovala.com";

export const getToken = (): string =>
  localStorage.getItem("access_token") || localStorage.getItem("token") || "";

export const authHeaders = (): Record<string, string> => {
  const token = getToken();
  return {
    "Content-Type": "application/json",
    Authorization: token ? "Bearer " + token : "",
  };
};

export const money = (n: number | string | null | undefined): string => {
  const v = Number(n) || 0;
  return (
    "$" +
    v.toLocaleString("en-CA", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
};